import { render, staticRenderFns } from "./BrandGrid.vue?vue&type=template&id=59ed63dc&scoped=true&"
import script from "./BrandGrid.vue?vue&type=script&lang=js&"
export * from "./BrandGrid.vue?vue&type=script&lang=js&"
import style0 from "./BrandGrid.vue?vue&type=style&index=0&id=59ed63dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ed63dc",
  null
  
)

export default component.exports